<template lang="html">
  <div class="">
    <base-header type="gradient-default" class="pb-6 pb-8 pt-5 pt-md-8">
      <span class="mask bg-dark opacity-8"></span>
      <form class="">
      </form>
    </base-header>
    <div class="container-fluid mt--7">
        <div class="row">
            <div class="col">
                <owner-payout-table title="Payout Table"></owner-payout-table>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import OwnerPayoutTable from '@/views/Tables/OwnerPayoutTable'

export default {
  components: {
    OwnerPayoutTable,
  },
}
</script>

<style lang="css" scoped>
</style>
